import { useCallback } from 'react';
import { useAppDispatch } from '#components/redux/hooks';
import { blockActions, unblockActions } from '#baseMenu/reducers/slice-menu';

const useMenuActionsBlocker = () => {
  const dispatch = useAppDispatch();

  const triggerBlockActions = useCallback(() => {
    dispatch(blockActions());
  }, [dispatch]);

  const triggerUnblockActions = useCallback(() => {
    dispatch(unblockActions());
  }, [dispatch]);

  return {
    blockActions: triggerBlockActions,
    unblockActions: triggerUnblockActions,
  };
};

export { useMenuActionsBlocker };
